import React, { useState } from "react";


import { CheckboxList, DropdownMulti } from "oolib";
import { AccordionMultiSelect } from "../../AccordionMultiSelect";
import { useGetOptionsByFilterType } from "./utils/useGetOptionsByFilterType";
import { handleFilterInputDisplayConditions } from "./utils/handleFilterInputDisplayConditions";
import { CustomSelectTopbarFilter } from "./comps/CustomSelectTopbarFilter";
import { AnnoHierarchyFilter } from "./comps/AnnoHierarchyFilter";
import { DocHierarchyFilter } from "./comps/DocHierarchyFilter";
import { TopicClusterFilter } from "./comps/TopicClusterFilter";

// these manage their own data fetching, state, and rendering.
const V3_FILTER_COMPS = {
  docHierarchyType: DocHierarchyFilter,
  annoHierarchyType: AnnoHierarchyFilter,
  topicClusteringNodeType: TopicClusterFilter,
};

export const FilterInput = ({
  id,
  onChange,
  value,
  comp = 'AccordionMultiSelect', //DropdownMulti //CheckboxList
  filterConfig,
  contentTypes = [],
  activeFilters = [],
  presetActiveFilters = [],
  className,
  initEnableDataFetch, //cuz in the case of mobile filters, we enable the data fetch the minute it mounts.
  debug,
}) => {
  
  const [ searchTerm, setSearchTerm ] = useState("");

  /**
   * Number range filters render an always-visible inline editor in the collapsed
   * accordion header (see AccordionHeader). That editor clamps typed values to the
   * fetched min/max bounds, so the bounds must be fetched eagerly rather than lazily
   * on expand — otherwise typed values get clamped to the 0–100 loading placeholder
   * and any field with a real range beyond 0–100 is silently truncated. This mirrors
   * the FilterOptionsPanel compact path, which sets initEnableDataFetch: true.
   */
  const isNumberRangeFilter = filterConfig?.source?.filterType === "numberRangeType";

  const {
    setEnableDataFetch,
    lightboxConfig,
    display,
    observerRef,
    isFetchingNextPage,
    hasNextPage
  } = useGetOptionsByFilterType({
    initEnableDataFetch: initEnableDataFetch || isNumberRangeFilter,
    filterConfig,
    contentTypes,
    activeFilters,
    searchTerm 
  })

  const [showDropdownOptions, setShowDropdownOptions] = useState(false)

  // dont render filter, if the display condition config says not to.
  let shouldRender = handleFilterInputDisplayConditions({
    activeFilters,
    presetActiveFilters,
    filterConfig
  })
  if(!shouldRender) return null;

  const FilterCompV3 = V3_FILTER_COMPS[filterConfig?.source?.filterType];
  if (FilterCompV3) {
      // onChange's 3rd arg is the change's origin meta (see FilterListItem) — it
      // has to be forwarded, else handleOnChange can't tell a picker edit from an
      // applied-block edit.
      return (
      <FilterCompV3
        filterConfig={filterConfig}
        value={value}
        onChange={(id, _value, meta) => onChange(id, _value, meta)}
        activeFilters={activeFilters}
      />
    );
  }
  
  const FilterComps = {
    DropdownMulti,
    AccordionMultiSelect,
    CheckboxList
    // --> some other accordion component 
    // --> CheckboxInput
  } 
  const FilterComp = FilterComps[comp]

  const getPropsByComp = comp => {
    switch(comp){
      case 'DropdownMulti':
        return ({
          broadcastShowOptions: (bool) => {
            setEnableDataFetch(bool) //this only set it to true, never false, 
            setShowDropdownOptions(bool) //hence we need another state to track showoptions
          },
          isSearchable: true,
          genCustomSelectComp: () => <CustomSelectTopbarFilter {...{ showOptions: showDropdownOptions, display }}/>
        })
      case 'AccordionMultiSelect':
        return ({
          broadcastExpandState: (bool) => setEnableDataFetch(bool),
          title: display,
          onSearchChange: setSearchTerm,
          observerRef: observerRef,
          isFetchingNextPage: isFetchingNextPage,
          hasNextPage: hasNextPage
        }) 
      case 'CheckboxList':
        return ({
          label: display,
          optionsLimit: 15,
          inputStyle: "tagSelect"
        }) 
        default: 
        return ({})
    }
  }

  return (

      <FilterComp
        id={filterConfig.filterId}     
        value={value}
        options={lightboxConfig?.props?.options} //only exists to support DropdownMulti & CheckboxList which will eventually be removed from filters
        lightboxConfig={lightboxConfig}
        onChange={(k,v) => onChange(filterConfig.filterId, v)}  
        className={className}
        filterConfig={filterConfig}
        debug={debug}
        {...getPropsByComp(comp)}
        />
    
  );
};
